<ph-dialog [open]="open"
           size="md"
           [heading]="'Add ' + (data?.onlyDepositAccounts ? 'deposit ' : '') + 'bank account'"
           (ph-close)="closeDialog()">
    <app-bank-account-properties *ngIf="open"
                                 #propertiesForm
                                 [onlyDepositAccounts]="data?.onlyDepositAccounts"></app-bank-account-properties>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" (click)="closeDialog()">Cancel</ph-button>
        <ph-button [disabled]="isSaving || propertiesForm?.plaidOpen || !propertiesForm?.form?.valid" (click)="saveAccount()">Save bank account</ph-button>
    </ph-actions>
</ph-dialog>
